import React from 'react';
import { FiGithub, FiLinkedin, FiArrowUp } from 'react-icons/fi';
import { personalInfo } from '../../data/portfolioData';
import { useScrollTop } from '../../hooks/useScrollTop';
import styles from './Footer.module.css';

const Footer = () => {
  const { isVisible, scrollToTop } = useScrollTop(300);

  return (
    <footer className={styles.footer}>
      <div className={styles.container}>
        <div className={styles.left}>
          © {new Date().getFullYear()} Usman Mahmood. All rights reserved.
        </div>
        
        <div className={styles.center}>
          Designed & Built by Usman Mahmood
        </div>
        
        <div className={styles.right}>
          <a href={personalInfo.github} target="_blank" rel="noreferrer" aria-label="GitHub">
            <FiGithub size={18} />
          </a>
          <a href={personalInfo.linkedin} target="_blank" rel="noreferrer" aria-label="LinkedIn">
            <FiLinkedin size={18} />
          </a>
        </div>
      </div>

      <button 
        className={`${styles.backToTop} ${isVisible ? styles.visible : ''}`}
        onClick={scrollToTop}
        aria-label="Back to Top"
      >
        <FiArrowUp size={20} />
      </button>
    </footer>
  );
};

export default Footer;
